// @flow

type ModuleWithDefaultExport = { +default: () => void, ... };

export const actionEntryPoints: {
  [actionName: string]: void | (() => Promise<ModuleWithDefaultExport>),
  ...
} = {
  frontPageIndex: () =>
    import('./actionSpecificSetup/frontPageIndex').then(m => ({
      default: m.init
    })),
  landingPagesShow: () =>
    import('./actionSpecificSetup/landingPagesShow').then(m => ({
      default: m.init
    })),
  listsShow: () => import('./actionSpecificSetup/listsShow'),
  reviewsNew: () => import('./actionSpecificSetup/reviewsNew'),
  'profiles/reviewsNew': () => import('./actionSpecificSetup/reviewsNew'),
  'profiles/venueProfilesShow': () =>
    import('./actionSpecificSetup/profiles/venueProfilesShow'),

  'profiles/admin/cateringProfilesEdit': () =>
    import('./actionSpecificSetup/profiles/admin/cateringProfilesEdit').then(
      m => ({ default: m.init })
    ),
  'catering/admin/menusIndex': () =>
    import('./actionSpecificSetup/catering/admin/menusIndex'),

  'admin/archives': () =>
    import('./actionSpecificSetup/admin/archives').then(m => ({
      default: m.archives
    })),
  'admin/inquiryRecipientsShow': () =>
    import('./actionSpecificSetup/admin/inquiryRecipientsShow'),
  'profiles/admin/venueProfilesEdit': () =>
    import('./actionSpecificSetup/profiles/admin/venueProfilesEdit').then(
      m => ({ default: m.venueProfilesEdit })
    ),
  'profiles/admin/venueProfilesIndex': () =>
    import('./actionSpecificSetup/profiles/admin/venueProfilesIndex'),

  'profiles/supplierProfilesEdit': () =>
    import('./actionSpecificSetup/profiles/supplierProfilesEdit').then(m => ({
      default: m.init
    })),

  'staff/imagesIndex': () => import('./actionSpecificSetup/staff/imagesIndex'),
  'staff/prospectsIndex': () =>
    import('./actionSpecificSetup/staff/prospectsIndex'),
  'staff/invoicesNew': () =>
    import('./actionSpecificSetup/staff/invoicesNew').then(m => ({
      default: m.init
    })),
  'staff/organizationsEdit': () =>
    import('./actionSpecificSetup/staff/organizationsEdit'),
  'staff/conversationAppAccessGroupSyncsIndex': () =>
    import('./actionSpecificSetup/staff/conversationAppAccessGroupSyncsIndex'),
  'staff/landingPagesEdit': () =>
    import('./actionSpecificSetup/staff/landingPagesEdit.js'),
  'staff/landingPagesNew': () =>
    import('./actionSpecificSetup/staff/landingPagesEdit.js'),
  'staff/cateringLandingPagesEdit': () =>
    import('./actionSpecificSetup/staff/cateringLandingPagesEdit.js'),
  'staff/cateringLandingPagesNew': () =>
    import('./actionSpecificSetup/staff/cateringLandingPagesEdit.js'),
  'staff/siteManagement/locationGeoShapesNew': () =>
    import(
      './actionSpecificSetup/staff/siteManagement/locationGeoShapesEdit'
    ).then(m => ({ default: m.init })),
  'staff/siteManagement/locationGeoShapesEdit': () =>
    import(
      './actionSpecificSetup/staff/siteManagement/locationGeoShapesEdit'
    ).then(m => ({ default: m.init })),
  'users/registrationsEdit': () =>
    import('./actionSpecificSetup/users/registrationsEdit')
};
